import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { checkPasswordConstraints } from '@gamelearn/skeletor/utils';
import { QuestionBase, TextboxQuestion, PasswordboxQuestion, SimpleSelectQuestion } from 'app/core';
const LANGS = [
  { key: 'en', value: 'languages.english' },
  { key: 'es', value: 'languages.spanish' },
  { key: 'fr', value: 'languages.french' },
  { key: 'cs', value: 'languages.czech' },
  { key: 'de', value: 'languages.german' },
  { key: 'it', value: 'languages.italian' },
  { key: 'nl', value: 'languages.dutch' },
  { key: 'pt', value: 'languages.portuguese' }
];
@Injectable()
export class AuthActivateQuestionsService {
  constructor() {}

  getQuestions(data: any, operation: string, serviceName: string): QuestionBase<any>[] {
    if (operation !== 'activation') {
      return this.getPasswordQuestions();
    }

    const userQuestions = ['campus', 'kepler', 'mars'].includes(serviceName)
      ? this.getUserInfoQuestions(data)
      : [];
    const langQuestion = serviceName === 'campus' ? this.getLanguageQuestions(data) : [];

    const questions: QuestionBase<any>[] = [
      new TextboxQuestion({
        key: 'userName',
        label: 'auth.mailLabel',
        value: data.userName,
        disabled: true,
        order: 1
      }),
      ...userQuestions,
      ...langQuestion,
      ...this.getPasswordQuestions()
    ];

    return questions.sort((a, b) => a.order - b.order);
  }

  getUserAndLangQuestions(data: {
    name: string;
    surname: string;
    lang: string;
  }): QuestionBase<any>[] {
    const questions = [...this.getUserInfoQuestions(data), ...this.getLanguageQuestions(data)];
    return questions;
  }

  getUserInfoQuestions(data: { name: string; surname: string }): QuestionBase<any>[] {
    return [
      new TextboxQuestion({
        key: 'name',
        label: 'nouns.name',
        value: data.name,
        placeholder: 'enrollment.register.placeholders.firstName',
        hidden: !!data.name && !!data.surname,
        order: 2
      }),
      new TextboxQuestion({
        key: 'surname',
        label: 'nouns.surname',
        placeholder: 'enrollment.register.placeholders.lastName',
        value: data.surname,
        hidden: !!data.name && !!data.surname,
        order: 3
      })
    ].filter((question) => question != null);
  }

  getLanguageQuestions(data: { lang: string }): QuestionBase<any>[] {
    return [
      new SimpleSelectQuestion({
        key: 'lang',
        label: 'nouns.lang',
        placeholder: 'enrollment.register.placeholders.lang',
        value: this.checkLang(data.lang) ? data.lang : 'en',
        items: LANGS,
        order: 4
      })
    ];
  }

  getPasswordQuestions(): QuestionBase<any>[] {
    return [
      new PasswordboxQuestion({
        key: 'password',
        label: 'auth.newPassword',
        placeholder: 'nouns.password',
        checkStrength: true,
        validators: {
          function: (formControl: FormControl<any>) => {
            const constraints = checkPasswordConstraints(formControl.value);
            if (Object.keys(constraints).some((check) => !constraints[check])) {
              return { invalidPassword: true };
            }
            if (formControl.dirty) {
              formControl.parent.controls['passwordConfirm'].updateValueAndValidity();
              formControl.markAsUntouched();
            }
            return null;
          }
        },
        order: 5
      }),
      new PasswordboxQuestion({
        key: 'passwordConfirm',
        label: 'auth.confirmPassword',
        placeholder: 'actions.passwordConfirm',
        validators: {
          // required: true,
          function: (formControl: FormControl<any>) => {
            return formControl.value &&
              formControl.value === formControl.parent.controls['password'].value
              ? null
              : { passwordMatch: false };
          }
        },
        order: 6
      })
    ];
  }

  checkLang(lang: string): boolean {
    const langs = LANGS.map((lang) => lang.key);
    return langs.includes(lang);
  }
}
